// Financial Selectors
export const selectWallet = (state) => state.financial.wallet;
export const selectWalletLoading = (state) => state.financial.wallet.loading;
export const selectWalletData = (state) => state.financial.wallet.data;
export const selectWalletError = (state) => state.financial.wallet.error;

export const selectTransactions = (state) => state.financial.transactions;
export const selectTransactionsLoading = (state) =>
  state.financial.transactions.loading;
export const selectTransactionsData = (state) =>
  state.financial.transactions.data;
export const selectTransactionsTotalCount = (state) =>
  state.financial.transactions.totalCount;

export const selectSettlements = (state) => state.financial.settlements;
export const selectSettlementsLoading = (state) =>
  state.financial.settlements.loading;
export const selectSettlementsData = (state) =>
  state.financial.settlements.data;

export const selectInvoices = (state) => state.financial.invoices;
export const selectInvoicesLoading = (state) =>
  state.financial.invoices.loading;
export const selectInvoicesData = (state) => state.financial.invoices.data;

export const selectSelectedInvoice = (state) => state.financial.selectedInvoice;
export const selectSelectedInvoiceLoading = (state) =>
  state.financial.selectedInvoice.loading;
export const selectSelectedInvoiceData = (state) =>
  state.financial.selectedInvoice.data;
export const selectSelectedInvoiceError = (state) =>
  state.financial.selectedInvoice.error;

export const selectPayments = (state) => state.financial.payments;
export const selectPaymentsLoading = (state) =>
  state.financial.payments.loading;
export const selectPaymentsData = (state) => state.financial.payments.data;
